import PropTypes from 'prop-types';

import PropTypesPresenter from '../utils/PropTypesPresenter';

const WELCOME = 'welcome';
const REFERRAL = 'referral';
const ADMIN_FEE_LIMIT = 'admin_fee_limit';
const ADMIN_FEE_AMOUNT = 'admin_fee_amount';
const MEMBERSHIP_FEE_AMOUNT = 'membership_fee_amount';
const ADMIN_FEE_REQUIRED_DAYS = 'admin_fee_required_days';
const WELCOME_BONUS_LIMIT = 'welcome_bonus_limit';

export const BONUS_CATEGORY = [WELCOME, REFERRAL, WELCOME_BONUS_LIMIT];
export const PAYMENT_CATEGORY = [
  ADMIN_FEE_LIMIT,
  ADMIN_FEE_AMOUNT,
  MEMBERSHIP_FEE_AMOUNT,
  ADMIN_FEE_REQUIRED_DAYS,
];

export const TYPES = [BONUS_CATEGORY, PAYMENT_CATEGORY].flat();

export default new PropTypesPresenter(
  {
    id: PropTypes.number,
    settingType: PropTypes.string,
    description: PropTypes.string,
    value: PropTypes.number,
  },
  {
    settingTypeReadable(membershipSetting) {
      const settingTypeMap = {
        [WELCOME]: 'Welcome bonus amount',
        [ADMIN_FEE_LIMIT]: 'Admin fee threshold',
        [ADMIN_FEE_AMOUNT]: 'Admin fee amount',
        [MEMBERSHIP_FEE_AMOUNT]: 'Membership fee amount',
        [ADMIN_FEE_REQUIRED_DAYS]: 'Admin fee period',
        [REFERRAL]: 'Referral bonus amount',
        [WELCOME_BONUS_LIMIT]: 'Welcome bonus threshold',
      };
      const settingType = this.settingType(membershipSetting);

      return settingTypeMap[settingType];
    },
  }
);
